let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hhEBL")).then(() => parcelRequire('2G217'));